import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'

const $ = window.$

class ConfirmationModal extends Component {

	constructor(props) {
		super(props)
	}

	validate = () => {
		if (this.props.values) {
			this.props.store.dispatch(this.props.actionOnValid(this.props.values))
		} else {
			this.props.store.dispatch(this.props.actionOnValid)
		}
	}

	componentDidMount() {
		$('.modal-confirmation').modal({
			dismissible: true,
			opacity: 0.7,
			inDuration: 300,
			outDuration: 200,
			startingTop: '4%',
			endingTop: '10%',
			size: 'small'
		})
	}

	render() {
		return (
			<div id={ this.props.id } className='modal-confirmation modal small-modal'>
				<div className='modal-content'>
					<h4>{ this.props.title }</h4>
					<p>{ this.props.content }</p>
				</div>
				<div className='modal-footer'>
					<a className='modal-action modal-close btn margin-right-10' onClick={ this.validate }>{ i18n.validate }</a>
					<a className='modal-action modal-close waves-effect waves-green btn red'>{ i18n.cancel }</a>
				</div>
			</div>
		)
	}
}

ConfirmationModal.propTypes = {
	id: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	store: PropTypes.object,
	actionOnValid: PropTypes.func,
	values: PropTypes.object
}

ConfirmationModal.defaultProps = {
	id: '',
	content: '',
	title: ''
}

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/components/modal/ConfirmationModal.js